import { message } from 'antd';
import mostrarErro from './error-handler';
import { createMetric } from '../repository/metricRepository';

export const readFileAsArrayBuffer = async (file) =>
  new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => resolve(e.target.result);
    fileReader.readAsArrayBuffer(file);
  });

export const binaryToArrayBuffer = (s) => {
  const buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
  const view = new Uint8Array(buf); // create uint8array as viewer
  for (let i = 0; i < s.length; i + 1) {
    // eslint-disable-next-line no-bitwise
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

export const handleFileDownload = async (callback) => {
  const hide = message.loading('Seu download está sendo preparado', 0);
  try {
    await callback();
  } catch (e) {
    mostrarErro(e);
  } finally {
    hide();
  }
};

export const handleDownloadWithMetrics = async (callback, metricsConfig = {}) => {
  const { key, source, details = {} } = metricsConfig;
  const hide = message.loading('Seu download está sendo preparado', 0);
  let status;
  try {
    await callback();
    status = 'success';
  } catch (e) {
    status = 'error';
    mostrarErro(e);
  } finally {
    hide();
    if (key) {
      await createMetric({
        key,
        source,
        details: { ...details, status },
      });
    }
  }
};
